import React from 'react';

import { ConsentBanner } from '@atlassian/browser-storage-controls/consent-banner';

import { useSSRPlaceholderReplaceIdProp } from '@confluence/loadable';

export const ConsentBannerWrapper = ({ ...props }: { [x: string]: any }): React.JSX.Element => {
	const ssrPlaceholderIdProp = useSSRPlaceholderReplaceIdProp();
	return (
		<div {...ssrPlaceholderIdProp} data-vc="consent-banner-wrapper">
			<ConsentBanner {...props} />
		</div>
	);
};
